<div *ngIf="footer.visible" id="footer-wrapper" ng-hide="globals.hideFooter">
   <div>
      <b>{{'g.copyright' | translate}} © {{yearAge}} {{'act.actview' | translate}}.</b> {{'g.all_rights_reserved' | translate}}
      <a routerLink="/contact-us" class="dark"><b>{{'g.contact_us' | translate}}</b></a>
     <!--  <% } else { %>
      <b>Copyright © {{yearAge}}</b> powered by ACT. All Rights Reserved.
      <% } %> -->
   </div>
</div>